export const demoViewModeKey = 'editorViewMode';

export enum DemoViewMode {
  WithoutCards = 'emptyState',
  WithCards = 'demo',
}
